<section class="survey-form u-margin-top-small  u-margin-bottom-medium max-width">

  @if(descriptionHtml){
    <div [innerHTML]="descriptionHtml"></div>
  }@else{
    <label for="" class="form-header-label" [ngStyle]="{'color':commentcardStyles.MainContentTextColor}" [innerHTML]="'Commentcardsubtitle' | translate"></label>
  }
  <div class="form">
    @for (question of questions; track question; let index = $index) {
      <div class="question-card" [ngClass]="{'question-card--no-border': question.type === 'text'}" [ngStyle]="{'border-color':commentcardStyles.CommentCardBackgroundColor}">
        <div class="question-card__question u-margin-bottom-small" [attr.data-tooltip]="question.Question" [attr.title]="question.Question" [ngStyle]="{'color':commentcardStyles.CommentCardTextColor, 'border-color':commentcardStyles.CommentCardTextColor}">@if (index+1 != questions.length) {
          <span class="question-card-numbering-outer">
          <span class="question-card-numbering-inner">{{index
          + 1}}. </span>
          </span>
        }<span class="question-card-question-text">{{question.Question}}</span></div>
        <div class="question-card__answer">
          @if (question.type === 'rating') {
            <div class="question-card__rating" (click)="checkaallselected()">
              @for (option of question.options; track option) {
                <button type="button" mat-button
                  [matTooltip]="option.label" matTooltipClass="custom-tooltip-bottom"
                  class="question-card__rate-item" (click)="question.rating = option.rating">
                  <span class="icon-fill">
                    @if (question.rating >= option.rating) {
                      <mat-icon aria-hidden="false" [ngStyle]="{'color':commentcardStyles.StarBackgroundColor}" aria-label="rating">
                      star</mat-icon>
                    }
                  </span>
                  <span class="icon-empty">
                    @if (question.rating < option.rating) {
                      <mat-icon aria-hidden="false" aria-label="rating">
                      star_border</mat-icon>
                    }
                  </span>
                </button>
              }
            </div>
          }
          <div class="question-card__choice"></div>
          @if (question.type === 'text') {
            <div class="question-card__text" [ngStyle]="{'color':commentcardStyles.CommentCardTextColor}">
              <mat-label class="user-feedback-label">{{'Commentcardfreetext' | translate}}</mat-label>
              <mat-form-field appearance="outline" class="form__input" floatLabel="never">
                <!-- <input [(ngModel)]="question.value" (input)="onSearchChange($event.target.value)" matInput [placeholder]="'Commentcardfreetext' | translate">-->
                <textarea [(ngModel)]="question.value" (input)="onSearchChange($event.target.value)" matInput [placeholder]="'Commentcardfreetextarea' | translate" rows="3"></textarea>
              </mat-form-field>
            </div>
          }
        </div>
      </div>
    }
    <div class="form__footer u-margin-top-small">
      <button class="btn-submit" [disabled]="isdatavalid" [ngStyle]="{'background-color': (isdatavalid ? commentcardStyles.ButtonLinkColor : 0 )}" mat-flat-button color="warn" type="submit"
      (click)="submit()">{{'submit' | translate}}</button>
      <button mat-stroked-button type="button" class="btn-cancel" (click)="reload()">Cancel</button>
    </div>
  </div>
</section>